import 'css-chunksrc/client/pages/projectPage/kanbanPage/collapsedColumn/styles.scss';export default {
  "collapsedColumn": "_collapsedColumn_1tw8l_1",
  "heading": "_heading_1tw8l_13",
  "title": "_title_1tw8l_25",
  "progressBar": "_progressBar_1tw8l_43",
  "icon": "_icon_1tw8l_50"
};